<agu-item-card
    class="agu-item-card--phone-accent"
    [Recommended]="Recommended"
    [IsNew]="Person.isNew"
    [Saved]="Person.itemState.saved"
    [Pinned]="Person.itemState.pinned"
    [ShowPin]="ShowPin"
    [ShowDismiss]="ShowDismiss"
    [ShowPinnedChip]="true"
    SaveLabel="Save person"
    (SaveToggled)="Save.emit($event)"
    (PinToggled)="Pin.emit($event)"
    (Dismissed)="Dismiss.emit()"
    (RowActivated)="Open.emit()"
>
    @if (NetworkChip) {
        <span chips class="agu-card__chip" data-tone="accent">{{ NetworkChip }}</span>
    }

    <div title class="ra-person-card__head">
        <span class="ra-person-card__avatar" aria-hidden="true">{{ Initials }}</span>
        <!-- h2 on the Saved board (P/for-you.html:947). -->
        @if (TitleLevel === 2) {
            <h2 class="ra-person-card__name">
                <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Person.name }}</button>
            </h2>
        } @else {
            <h3 class="ra-person-card__name">
                <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Person.name }}</button>
            </h3>
        }
    </div>

    <p sub class="ra-person-card__role">
        {{ RoleLine }}@if (Person.location) {<br />{{ Person.location }}}
    </p>

    @if (WhyItems.length > 0) {
        <div why class="ra-person-card__why">
            <div class="ra-person-card__why-label">What you share</div>
            <ul class="ra-person-card__why-list">
                @for (item of WhyItems; track item.label) {
                    <li>
                        <span class="ra-person-card__why-icon" [attr.title]="item.title">
                            <i class="fa-solid {{ item.icon }}" aria-hidden="true"></i>
                        </span>
                        {{ item.label }}
                    </li>
                }
            </ul>
            @if (SharedTotal > WhyItems.length) {
                <button type="button" class="ra-person-card__why-more" (click)="Open.emit()">See all {{ SharedTotal }} shared</button>
            }
        </div>
    }

    @if (Person.orcid || Person.linkedInUrl) {
        <div why class="ra-person-card__links">
            @if (Person.orcid) {
                <a class="ra-person-card__id-link" [href]="'https://orcid.org/' + Person.orcid" target="_blank" rel="noopener">
                    <span class="ra-person-card__id-badge" aria-hidden="true">iD</span>
                    ORCID
                </a>
            }
            @if (Person.linkedInUrl) {
                <a class="ra-person-card__id-link" [href]="Person.linkedInUrl" target="_blank" rel="noopener">
                    <span class="ra-person-card__linkedin" aria-hidden="true">in</span>
                    LinkedIn
                </a>
            }
        </div>
    }

    <button type="button" ctas class="agu-card__cta agu-card__cta--quiet" (click)="Open.emit()">View details</button>
    @if (Person.aguProfileUrl) {
        <a ctas class="agu-card__cta agu-card__cta--primary" [href]="Person.aguProfileUrl" target="_blank" rel="noopener">AGU profile <span aria-hidden="true">↗</span></a>
    } @else {
        <button type="button" ctas class="agu-card__cta agu-card__cta--primary" disabled>AGU profile</button>
    }
</agu-item-card>
